import { amountPaid } from './amount-paid';
import { assignedTo } from './assigned-to';
import { batchName } from './batch-name';
import { carrier } from './carrier';
import { city } from './city';
import { company } from './company';
import { country } from './country';
import { createdDate } from './created-date';
import { delegationDate } from './delegation-date';
import { labelCreated } from './label-created';
import { marketplaceNotified } from './marketplace-notified';
import { orderDate } from './order-date';
import { orderNumber } from './order-number';
import { packingSlipPrinted } from './packing-slip-printed';
import { paidDate } from './paid-date';
import { postalCode } from './postal-code';
import { provider } from './provider';
import { quantity } from './quantity';
import { recipient } from './recipient';
import { service } from './service';
import { shipDate } from './ship-date';
import { shipmentNotification } from './shipment-notification';
import { shipmentNumber } from './shipment-number';
import { shippingPaid } from './shipping-paid';
import { source } from './source';
import { state } from './state';
import { status } from './status';
import { store } from './store';
import { taxPaid } from './tax-paid';
import { tracking } from './tracking';
import { weight } from './weight';

export const fulfillmentColumns = [
  amountPaid,
  assignedTo,
  batchName,
  carrier,
  city,
  company,
  country,
  createdDate,
  delegationDate,
  labelCreated,
  marketplaceNotified,
  orderDate,
  orderNumber,
  packingSlipPrinted,
  paidDate,
  postalCode,
  provider,
  quantity,
  recipient,
  service,
  shipDate,
  shipmentNotification,
  shipmentNumber,
  shippingPaid,
  source,
  state,
  status,
  store,
  taxPaid,
  tracking,
  weight,
];
